// v2.19.29c — Drapeau Côte d'Ivoire en SVG inline (garantit le rendu sur tous OS,
// même ceux sans support natif des emoji indicateurs régionaux).
// Couleurs officielles : orange #F77F00, blanc #FFFFFF, vert #009E60.
export default function FlagCi({ size = 16, style = {} }) {
  return (
    <svg
      width={size}
      height={Math.round(size * 0.667)}
      viewBox="0 0 9 6"
      aria-label="Drapeau Côte d'Ivoire"
      data-testid="flag-ci"
      style={{
        display: "inline-block",
        verticalAlign: "-2px",
        marginLeft: 4,
        marginRight: 1,
        borderRadius: 2,
        boxShadow: "0 0 0 0.5px rgba(0,0,0,0.18)",
        ...style,
      }}
    >
      <rect width="3" height="6" x="0" fill="#F77F00" />
      <rect width="3" height="6" x="3" fill="#FFFFFF" />
      <rect width="3" height="6" x="6" fill="#009E60" />
    </svg>
  );
}

// Helper : remplace les occurrences de 🇨🇮 dans un string par <FlagCi />.
// Retourne un tableau React mêlant strings et composants → utilisable dans
// n'importe quel render JSX `<div>{renderWithFlag(text)}</div>`.
export function renderWithFlag(text, flagProps = {}) {
  if (!text) return text;
  const parts = String(text).split("🇨🇮");
  if (parts.length === 1) return text; // pas d'emoji présent
  const out = [];
  parts.forEach((p, i) => {
    out.push(p);
    if (i < parts.length - 1) out.push(<FlagCi key={`f-${i}`} {...flagProps} />);
  });
  return out;
}
